import HostfullyIcon from 'assets/images/icons/channels/hostfully.svg?react';
import RadioGroupField from 'components/forms/radioGroupField/RadioGroupField';
import { useTranslation } from 'react-i18next';
import {
  RadioIconsContainer,
  RadioOptionsContainer,
} from './PropertyFeeModal.styles';
import useFormData from './useFormData';

interface Props {
  labelInputSizes: {
    colSmLabel: number;
    colSmInput: number;
  };
}

const RollIntoRentField = ({ labelInputSizes }: Props) => {
  const { t } = useTranslation();
  const { isAppliedToHostfully, isRollInFeeIntoRent, isTypeFee, isOptional } =
    useFormData();

  const isHiddenByAppliesToHostfully =
    !isAppliedToHostfully && !isRollInFeeIntoRent;
  const isHiddenByOptionalFee = isTypeFee && isOptional && !isRollInFeeIntoRent;
  const isHidden = isHiddenByAppliesToHostfully || isHiddenByOptionalFee;

  if (isHidden) {
    return null;
  }

  return (
    <RadioOptionsContainer>
      <RadioGroupField
        horizontal
        name="rollsIntoRent"
        label={t(
          'pageProperty.feesTaxesAndPolicies.propertyFeesAndTaxes.addModal.rollInFeeIntoRent',
        )}
        options={[
          { value: 'NO', label: t('common.no') },
          { value: 'YES', label: t('common.yes') },
        ]}
        {...labelInputSizes}
      />
      <RadioIconsContainer>
        <HostfullyIcon />
      </RadioIconsContainer>
    </RadioOptionsContainer>
  );
};

export default RollIntoRentField;
